import { useCallback, useEffect, useState } from 'react';
import { useNotifications } from '../../../hooks/useNotifications';
import { IncidentsService } from '../../../services/incidentsService';
import { FileUploadsService } from '../../../services/fileUploadService';

const useMobileFormActions = (serviceId) => {
  const [isLoading, setLoading] = useState();
  const { showSuccessNotification, showErrorNotification } = useNotifications();
  const [isUpdateAfterFinish, setIsUpdateAfterFinish] = useState();

  const getEvidencesSignedPost = useCallback(
    async ({ file, idInput, parents }) => {
      try {
        if (file) {
          const result = await IncidentsService.getEvidencesSignedPost(serviceId, {
            idInput,
            parents,
            file,
          });

          return result;
        }
      } catch (error) {
        console.error(error);
      }
    },
    [showSuccessNotification],
  );

  const getAttachmentsSignedPost = useCallback(
    async ({ file, idInput, parents }) => {
      try {
        if (file) {
          const { signedPost, path } = await IncidentsService.getAttachmentsSignedPost(serviceId, {
            idInput,
            parents,
            file,
          });
          await FileUploadsService.uploadSignedFile(signedPost, file)
          return { fileKey: path }
        }
      } catch (error) {
        console.error(error);
      }
    },
    [],
  );

  const getService = async () => {
    try {
      const result = await IncidentsService.getById(serviceId);
      setIsUpdateAfterFinish(result?.idTypeService?.updateAfterFinish);
    } catch (error) {
      console.error(error);
    }
  };

  const updateMobileFormField = async (data) => {
    setLoading(true);
    try {
      await IncidentsService.updateMobileForm(serviceId, data);

      showSuccessNotification({
        title: 'success',
        description: 'successUpdatingRecord',
      });
    } catch (error) {
      showErrorNotification({
        title: 'error',
        description: 'errorUpdatingRecord',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceId) {
      getService();
    }
  }, [serviceId]);

  return {
    updateMobileFormField,
    isLoading,
    getEvidencesSignedPost,
    isUpdateAfterFinish,
    getAttachmentsSignedPost,
  };
};

export default useMobileFormActions;
